import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useCheckUserRole } from '../pages/hooks/useCheckUserRole';
import { FaEye, FaEyeSlash } from 'react-icons/fa'; // Font Awesome ikonlarını ekleyin


const Profile = () => {

    const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem('isLoggedIn') === 'true');
    const [userData, setUserData] = useState({
        username: '',
        email: '',
        tg_link: '',
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
        subscriptionEndDate: ''  // Yeni alan
    });

        // Kullanıcı rolünü kontrol edin
        useCheckUserRole(['admin', 'editor', 'user']); // Bu satır, kullanıcı rolünü kontrol eder
    
    const [message, setMessage] = useState('');
    const navigate = useNavigate();
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showNewPasswords, setShowNewPasswords] = useState(false);

    useEffect(() => {
        const storedIsLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
        setIsLoggedIn(storedIsLoggedIn);

        if (!storedIsLoggedIn) {
            navigate('/login');
        } else {
            fetchProfileData();
        }
    }, [navigate]);

    const fetchProfileData = async () => {
        try {
            const response = await axios.get('/api/profile');
            setUserData({
                username: response.data.username,
                email: response.data.email,
                tg_link: response.data.tg_link,
                currentPassword: '',
                newPassword: '',
                confirmPassword: '',
                subscriptionEndDate: response.data.subscription_end_date // Abonelik bitiş tarihi
            });
        } catch (error) {
            console.error('Profil verisi alınırken hata oluştu:', error);
        }
    };
    

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setUserData({ ...userData, [name]: value });
    };

    const handleTelegramUpdate = async () => {
        try {
            const response = await axios.put('/api/profile/tg-link', { tg_link: userData.tg_link });
            if (response.data.success) {
                setMessage('Telegram linki başarıyla güncellendi.');
                window.location.reload(); // Sayfayı yenile
            }
        } catch (error) {
            console.error('Telegram linki güncellenirken hata oluştu:', error);
            setMessage('Telegram linki güncellenirken hata oluştu.');
        }
    };

    const handlePasswordUpdate = async (e) => {
        e.preventDefault();
        if (userData.newPassword !== userData.confirmPassword) {
            setMessage('Yeni şifreler eşleşmiyor.');
            return;
        }

        try {
            const response = await axios.put('/api/profile/password', {
                currentPassword: userData.currentPassword,
                newPassword: userData.newPassword
            });
            if (response.data.success) {
                setMessage('Şifre başarıyla güncellendi.');
                window.location.reload(); // Sayfayı yenile
            } else {
                setMessage(response.data.message);
            }
        } catch (error) {
            console.error('Şifre güncellenirken hata oluştu:', error);
            setMessage('Şifre güncellenirken hata oluştu.');
        }
    };

    return (
        <div>
            {/* Breadcrumb Section */}
            <div className="breadcrumb-section breadcrumb-bg">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 offset-lg-2 text-center">
                            <div className="breadcrumb-text">
                                <p></p>
                                <h1>Profil</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Profile Form */}
            <div className="container mt-5">
                <div className="profile-container">
                    {/* Kullanıcı Bilgileri */}
                    <div className="profile-info">
                        <div className="mb-3">
                            <h4>Kullanıcı Bilgileri</h4>
                            <p><strong>Kullanıcı Adı:</strong> {userData.username}</p>
                            <p><strong>E-posta:</strong> {userData.email}</p>
                            <p><strong>Paket Bitiş Tarihi:</strong> {userData.subscriptionEndDate 
                                ? new Date(userData.subscriptionEndDate).toLocaleDateString() 
                                : 'Aktif Paket yok'}
                            </p>
                        </div>


                        {/* Telegram Linki Güncelleme */}
                        <form onSubmit={(e) => e.preventDefault()}>
                            <div className="mb-3">
                                <label htmlFor="tg_link" className="form-label">Telegram Linki</label>
                                <input
                                    type="text"
                                    className="form-control input-box"
                                    id="tg_link"
                                    name="tg_link"
                                    value={userData.tg_link}
                                    onChange={handleInputChange}
                                />
                                <button type="button" className="telegram-button" onClick={handleTelegramUpdate}>
                                    Telegram Linkini Güncelle
                                </button>
                            </div>
                        </form>
                    </div>

                    {/* Şifre Güncelleme */}
                    <div className="password-update">
                        <form onSubmit={handlePasswordUpdate}>
                            <div className="mb-3 position-relative">
                                <label htmlFor="currentPassword" className="form-label">Mevcut Şifre</label>
                                <input
                                    type={showCurrentPassword ? 'text' : 'password'}
                                    className="form-control input-box"
                                    id="currentPassword"
                                    name="currentPassword"
                                    value={userData.currentPassword}
                                    onChange={handleInputChange}
                                    required
                                />
                                <button
                                    type="button"
                                    className="end-0 top-50 translate-middle-y border-0 bg-transparent"
                                    style={{ right: '10px', cursor: 'pointer' }}
                                    onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                                >
                                    {showCurrentPassword ? <FaEyeSlash /> : <FaEye />}
                                </button>
                            </div>
                            <div className="mb-3 position-relative">
                                <label htmlFor="newPassword" className="form-label">Yeni Şifre</label>
                                <input
                                    type={showNewPasswords ? 'text' : 'password'}
                                    className="form-control input-box"
                                    id="newPassword"
                                    name="newPassword"
                                    value={userData.newPassword}
                                    onChange={handleInputChange}
                                />
                                <label htmlFor="confirmPassword" className="form-label">Yeni Şifre (Tekrar)</label>
                                <input
                                    type={showNewPasswords ? 'text' : 'password'}
                                    className="form-control input-box"
                                    id="confirmPassword"
                                    name="confirmPassword"
                                    value={userData.confirmPassword}
                                    onChange={handleInputChange}
                                />
                                <button
                                    type="button"
                                    className="end-0 top-50 translate-middle-y border-0 bg-transparent"
                                    style={{ right: '10px', cursor: 'pointer' }}
                                    onClick={() => setShowNewPasswords(!showNewPasswords)}
                                >
                                    {showNewPasswords ? <FaEyeSlash /> : <FaEye />}
                                </button>
                            </div>
                            {message && <p className="text-danger">{message}</p>}
                            <button type="submit" className="password-button">Şifreyi Güncelle</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Profile;